function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.25 13C13.2167 13 14.0417 12.6583 14.725 11.975C15.4083 11.2917 15.75 10.4667 15.75 9.5C15.75 8.53333 15.4083 7.70833 14.725 7.025C14.0417 6.34167 13.2167 6 12.25 6C11.2833 6 10.4583 6.34167 9.775 7.025C9.09167 7.70833 8.75 8.53333 8.75 9.5C8.75 10.4667 9.09167 11.2917 9.775 11.975C10.4583 12.6583 11.2833 13 12.25 13ZM5.25 21C4.7 21 4.229 20.8043 3.837 20.413C3.44567 20.021 3.25 19.55 3.25 19V5C3.25 4.45 3.44567 3.979 3.837 3.587C4.229 3.19567 4.7 3 5.25 3H19.25C19.8 3 20.271 3.19567 20.663 3.587C21.0543 3.979 21.25 4.45 21.25 5V19C21.25 19.55 21.0543 20.021 20.663 20.413C20.271 20.8043 19.8 21 19.25 21H5.25ZM5.25 19H19.25V17.85C18.35 16.9667 17.3043 16.2707 16.113 15.762C14.921 15.254 13.6333 15 12.25 15C10.8667 15 9.57933 15.254 8.388 15.762C7.196 16.2707 6.15 16.9667 5.25 17.85V19Z",
  fill: "#F2512D"
});

function SvgMineReverse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMineReverse);
export default __webpack_public_path__ + "static/media/mine_reverse.525e3fab.svg";
export { ForwardRef as ReactComponent };